<template>
  <div class="component-wrapper ">
    <div v-if="imageUrl" class=" row    image-wrapper">
      <div class="col-md-6 mb-4  mb-lg-0">
        <div :style="getBackgroundStyle(imageUrl)" class="service-heading-image"></div>
      </div>
      <div class="col-md-6  d-flex justify-content-center align-items-center  ">
        <div class="inner-wrapper">
          <div class="title"> {{ title }}</div>
          <div class="subtitle"> {{ subtitle }}</div>
          <div class="description"> {{ description }}</div>
          <div class="d-md-flex align-items-center">
            <div v-if="price" class="title me-3 mb-3 mb-lg-0"> {{ price }}</div>
            <MainButton :button-text="$t('book-appointment-online')" :icon="'calendar'" :size="'medium'"
                        :theme="'solid-blue'"/>
          </div>
        </div>

      </div>
    </div>
    <div v-else class="row g-0 no-image-wrapper">
      <div class="col-md-7 d-flex justify-content-end align-items-center ">
        <div class="inner-wrapper">
          <div class="title"> {{ title }}</div>
          <div class="subtitle"> {{ subtitle }}</div>
          <div class="description"> {{ description }}</div>
          <div class="d-md-flex align-items-center">
            <div v-if="price" class="title me-3 mb-3 mb-lg-0"> {{ price }}</div>
            <MainButton :button-text="$t('book-appointment-online')" :icon="'calendar'" :size="'medium'"
                        :theme="'solid-blue'"/>
          </div>


        </div>

      </div>
      <div class="col-md-5 d-none d-md-flex justify-content-end align-items-end">
        <div class="">
          <img alt="no image" class="background-image" src="/static/images/unihospital-logo-for-background.webp"/>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import MainButton from "@/components/Common/Buttons/MainButton.vue";

export default {
  name: 'OneOfficeHeadingComponent',
  components: {MainButton},
  props: {
    title: {
      type: String,
    },
    description: {
      type: String,
    },
    subtitle: {
      type: String,
    },
    imageUrl: {
      type: String,
    },
    price: {
      type: String,
    },
  },
  methods: {
    getBackgroundStyle(imageUrl) {
      return {
        backgroundImage: `url(${imageUrl})`,

      };
    },
  },
};
</script>

<style lang="scss" scoped>
.component-wrapper {

  color: $color-brown;
  background: $color-white;


  .no-image-wrapper {
    background: $color-grey;
    border-radius: 30px;

    overflow: hidden;
  }

  .inner-wrapper {
    border-radius: 30px;
    background: $color-grey;
    padding: 40px 20px;
  }

  .image-wrapper {
    border-radius: 30px;
    min-height: 600px;
    overflow: hidden;


    .service-heading-image {

      background-repeat: no-repeat;
      background-size: cover;
      background-position: center;
      width: 100%;
      border-radius: 30px;
      min-height: 400px;

    }
  }


  .title {
    font-size: $title-h5;
    line-height: 1;
    font-family: $font-bold;
  }

  .subtitle {
    margin-top: $spacing-1;
    text-decoration: underline;
    cursor: pointer;
  }

  .description {
    margin: $spacing-5 0;
    font-size: $paragraph-1;
    line-height: $paragraph-1-lh;

  }


}

@media screen and (min-width: 768px) {
  .component-wrapper {
    .image-wrapper {
      .inner-wrapper {
        padding: 80px;
        min-height: 600px;
      }

      .service-heading-image {
        min-height: 600px;
        border-radius: 30px;
      }
    }

    .no-image-wrapper {
      min-height: 600px;

      .inner-wrapper {
        padding: 100px;
      }
    }

    .title {
      font-size: $title-h3;
      line-height: $title-h3;
    }

    .description {
      max-width: 80%;
    }
  }

}
</style>
